import React from "react";
import { Content } from "../components/Content";
import Messages from "../components/Messages";
import { logout } from "../components/Login";
import { ExitButton } from "../components/AdditionalButton";

class AccountCreated extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      details: null,
      login: null,
    };
  }

  componentDidMount() {
    //const fromRedirect = this.props.history.action !== 'POP';

    // if (!fromRedirect) {
    //     return this.props.history.push({
    //         pathname: '/'
    //     })
    // }

    const { details, login } = this.props.location.state;
    const message = "Sua conta institucional foi criada com sucesso.";
    
    this.setState({
      message: message,
      details: details,
      login: login,
      fromRedirect: this.props.history.action === "REPLACE",
    });
  }

  renderElement() {
    return (
      <Content stepName="Escolha da sua conta">
        <Messages.successMessage
          message={this.state.message}
          details={this.state.details}
        />
        <br />
        <h2 className="text text-lg-center">
          <strong>Sua Conta Institucional é:</strong>
        </h2>
        <div className="text text-center">
          <h2>
            <span className="badge badge-secondary">{this.state.login}</span>
          </h2>
        </div>

        <br />
        {/* <p className="text text-center text-muted">
                    Agora você pode acessar os serviços institucionais com sua conta institucional <strong>({this.state.login}) </strong> e senha
                </p>
                <p className="text text-center text-muted">
                    O serviços que já podem ser acessados com a conta institucional são:
                    e-Campus, Webmail e Moodle caso você tenha acesso a eles.
                </p>
                <div className="row">
                    <a href="https://mail.ufvjm.edu.br" target="_blank" style={{ padding: '5px' }}>
                        <div className="card text-center">
                            <FontAwesomeIcon className="center" icon={['far', 'envelope']} size="3x" color="#3c763d" />
                            <div className="card-body">
                                <p className="card-text text-sm-left" style={{ color: '#3c763d' }}>Webmail UFVJM</p>
                            </div>
                        </div>
                    </a>
                    <a href="https://ecampus.ufvjm.edu.br" target="_blank" style={{ padding: '5px' }}>
                        <div className="card text-center">
                            <img src={ecampusLogo} className="center" alt='e-Campus' />
                            <div className="card-body">
                                <p className="card-text text-sm-left" style={{ color: '#3c763d' }}>e-Campus</p>
                            </div>
                        </div>
                    </a>
                </div>
                <p className="text text-center text-muted">
                    Em breve novos serviços serão unificados..."
                </p> */}
        <br />
        <ExitButton />
      </Content>
    );
  }

  exit = () => {
    logout();
    window.location = "https://sistemas.apps-teste.ufvjm.edu.br/";
  };

  render() {
    return this.renderElement();
  }
}

export default AccountCreated;
